import { render } from "./ImageProfile.vue?vue&type=template&id=a67d25e8"
import script from "./ImageProfile.vue?vue&type=script&lang=js"
export * from "./ImageProfile.vue?vue&type=script&lang=js"

import "./ImageProfile.vue?vue&type=style&index=0&id=a67d25e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__